import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchModuleSelection} from './../actions/ModuleActions';


const ModuleSlice = createSlice({
  name: 'module',
  initialState: {
    moduleSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchModuleSelection.pending, (state) => {
        state.moduleSelection.status = 'loading';
      })
      .addCase(fetchModuleSelection.fulfilled, (state, action) => {
        state.moduleSelection.status = 'idle';
        state.moduleSelection.data = action.payload.result;
      })
      .addCase(fetchModuleSelection.rejected, (state, action) => {
        state.moduleSelection.status = 'rejected';
        state.moduleSelection.error = action.error.message;
      });
  },
});


export default ModuleSlice.reducer;
